module.exports = __webpack_public_path__ + "static/media/super-prize.79a4c137.webp";